import { UIComponentImpl, UIComponentState, UIDataModel, UIComponentHandler, UIComponentProps } from '../../../../../toolkit/uicomponent';
import { BaseContext } from '../../../../../../utils/basecontext';
import { UIComponentView } from '../../../../../toolkit/uicomponentview';
import { CategoriesCardViewImpl } from './categoriescardview';
import { UIComponentCSSStyle } from '../../../../../toolkit/uicomponentcss';
import { CategoryDto } from '../../../../../../core/dto/categories/categorydto';
import { CategoriesCardCSSStyleImpl } from './categoriescardcssstyle';

export interface CategoriesCardComponentProps extends UIComponentProps
{
    categoryDto: CategoryDto;
    position: number;

    onSelected(categoryDto: CategoryDto): void;
}

export interface CategoriesCardComponentHandler extends UIComponentHandler
{
    onSelected(): void;
    onHovered(isHovered: boolean): void;
}

export interface CategoriesCardComponentState extends UIComponentState
{
    isHovered: boolean;
}

export class CategoriesCardComponent extends UIComponentImpl<CategoriesCardComponentProps, UIComponentState, UIDataModel> implements CategoriesCardComponentHandler
{
   
    constructor(props: CategoriesCardComponentProps)
    {
        super(props);

        this.state = {isHovered: false};
    }

    protected createComponentView(applicationContext: BaseContext, uiComponentHandler: UIComponentHandler): UIComponentView<UIDataModel>
    {
        return new CategoriesCardViewImpl(applicationContext, uiComponentHandler);
    }

    protected createComponentCSS(applicationContext: BaseContext): UIComponentCSSStyle
    {
        return new CategoriesCardCSSStyleImpl(applicationContext);
    }

    onHovered(isHovered: boolean): void {
        this.setState({isHovered: isHovered});
    }

    onSelected(): void 
    {
       this.props.onSelected(this.props.categoryDto);
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/components/home/categories/viewmodel/categoriescard/categoriescardcomponent.tsx